import anime, { AnimeInstance, AnimeParams } from "animejs";
import { ScrollDirection, ScrollHandler } from "../classes/scroll-manager";
import SceneManager from "../classes/scene-manager";
import { elementHeight, getEl } from "../helpers";
import App from "../index";

export interface ScrollAnimation
{
	anim: AnimeInstance,
	targetProgress: number,
	scrollStart: number,
	scrollEnd: number,
	smoothSpeed: number,
	duration: number,
	onEnteredView: () => any,
	onExitedView: () => any,
	enabled: boolean,
	onScroll: (dir:ScrollDirection, progress?: number, oldProgress?: number) => any,

}

export default class ScrolllockedAnimations
{
	public app:App;

	private lastDelta: number = 0;

	public isFrameRequested = false;

	public animations: ScrollAnimation[] = [];

	constructor(app: App) {
		this.app = app;

		this.onAnimationFrame = this.onAnimationFrame.bind(this);
	}

	public addScrollAnimation(anim: AnimeParams|AnimeInstance, containerElement: string|Element, smoothingTime: number = 500, scrollStart: number = 0, scrollEnd: number = 1, extraVhAbove: number = 0, extraVhBelow: number = 0, windowStartAt: number = 0.8)	{
		let ainstance: AnimeInstance;
		if (!("seek" in anim)) {
			anim.autoplay = false;
			ainstance = anime(anim);
		}
		else
		{
			ainstance = anim as AnimeInstance;
		}

		const thisAnim: ScrollAnimation = {
			enabled: true,
			anim: ainstance,
			onEnteredView: () => {},
			onExitedView: () => {},
			onScroll: null,
			targetProgress: 0,
			scrollStart: scrollStart,
			scrollEnd: scrollEnd,
			duration: 0,
			smoothSpeed: 1 / smoothingTime,
		};

		thisAnim.duration = thisAnim.anim.duration;

		thisAnim.onScroll = (dir, progress, oldProgress) => {
			thisAnim.targetProgress = progress*100;
			this.askForFrame();
		};

		this.app.scroller.addScrollTrigger(
			containerElement,
			thisAnim,
			windowStartAt, scrollStart, scrollEnd, extraVhAbove, extraVhBelow, false
		);

		this.animations.push(thisAnim);

		return thisAnim;
	}

	public askForFrame()
	{
		if (!this.isFrameRequested) {
			this.lastDelta = 0;
			requestAnimationFrame(this.onAnimationFrame);
			this.isFrameRequested = true;
		}
	}

	public onAnimationFrame(delta: number)
	{
		if (this.lastDelta == 0) this.lastDelta = delta;
		this.isFrameRequested = false;
		let needAnotherFrame = false;
		let deltaFrac = (delta-this.lastDelta);

		for (let i = 0; i < this.animations.length; i++) {
			if (!this.animations[i].enabled) continue;

			if (this.animations[i].anim && Math.abs(this.animations[i].anim.progress-this.animations[i].targetProgress) > 0.002) {
				let v = (this.animations[i].targetProgress - this.animations[i].anim.progress) * (deltaFrac*this.animations[i].smoothSpeed);
				//console.log("Updated animation progress: ", this.animations[i].anim.progress,' -> ', this.animations[i].targetProgress);
				// if (this.animations[i].targetProgress > this.animations[i].anim.progress)
				// {
				//
				// }
				this.animations[i].anim.seek((this.animations[i].anim.progress + v)/100 * this.animations[i].duration);
				needAnotherFrame = true;
			} else
			{
				this.animations[i].anim.seek((this.animations[i].targetProgress)/100 * this.animations[i].duration);
			}
		}
		if (needAnotherFrame) this.askForFrame();
		this.lastDelta = delta;
	}
	
	public enableAnimation(scrollAnim:ScrollAnimation)
	{
		if (!scrollAnim.enabled) {
			scrollAnim.enabled = true;
			this.askForFrame();
		}
	}
	
	public disableAnimation(scrollAnim: ScrollAnimation)
	{
		if (scrollAnim.enabled) {
			scrollAnim.enabled = false;
			if (scrollAnim.anim) {
				for (let i = 0; i < scrollAnim.anim.animatables.length; i++) {
					if (scrollAnim.anim.animatables[i].target) {
						scrollAnim.anim.animatables[i].target.removeAttribute('style');
					}
				}
			}
		}
	}

}
